module.exports = __webpack_public_path__ + "static/media/5.ef7ab7d3.JPG";